import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import styled from 'styled-components';
import InProgressDot from '../ContentCards/ReducedContentCard/subcomponents/InProgressDot';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import FormattedList from 'I18n/components/FormattedList';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
// @ts-expect-error untyped dependency
import FormattedDuration from 'I18n/components/FormattedDuration';
import { useTrack, useTrackProgressTime } from '../../features/tracks';
import { FILTER_CONSTS } from '../../constants/TopFilterConstants';
import { useAssetStatus, useRemainingLessons } from '../../features/userProgress/userProgressQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReadoutLessonBox = styled(UIBox).withConfig({
  displayName: "TrackCardTimeReadout__ReadoutLessonBox",
  componentId: "del5u-0"
})(["display:flex;&::after{content:'';margin:0 10px 0 10px;display:inline-flex;align-self:center;height:100%;}"]);
const ReadoutLessonBoxUnstarted = styled(ReadoutLessonBox).withConfig({
  displayName: "TrackCardTimeReadout__ReadoutLessonBoxUnstarted",
  componentId: "del5u-1"
})(["&::after{border-left:1px solid ", ";height:10px;}"], BATTLESHIP);
const InProgressLargeCardDot = styled(InProgressDot).withConfig({
  displayName: "TrackCardTimeReadout__InProgressLargeCardDot",
  componentId: "del5u-2"
})(["bottom:-9px;margin-left:3px;margin-right:9px;"]);
export const TrackCardTimeReadout = ({
  trackId
}) => {
  const {
    track
  } = useTrack(trackId);
  const {
    status
  } = useAssetStatus({
    id: trackId,
    type: 'TRACK'
  });
  const {
    remainingTime,
    totalTime
  } = useTrackProgressTime(trackId);
  const {
    totalLessons,
    remainingLessons
  } = useRemainingLessons({
    lessonIds: track && track.lessonIds ? track.lessonIds.map(lessonId => Number(lessonId)) : []
  });
  const showProgress = status && status !== FILTER_CONSTS.STATUSES.NOT_STARTED;
  return /*#__PURE__*/_jsxs(UIFlex, {
    children: [showProgress && /*#__PURE__*/_jsx(InProgressLargeCardDot, {}), showProgress ? /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(ReadoutLessonBox, {
        children: /*#__PURE__*/_jsxs(FormattedList, {
          exclusive: true,
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-test-id": "track-total-lessons",
            message: "academyComponents.reducedContentCards.numLessonsRemaining",
            options: {
              remainingNumber: remainingLessons,
              totalNumber: totalLessons
            }
          }), /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "learningCenter.tracks.timeRemaining.duration",
            options: {
              duration: /*#__PURE__*/_jsx(FormattedDuration, {
                from: new Date().getTime() - remainingTime * 1000
              })
            }
          })]
        })
      })
    }) : remainingLessons > 0 && /*#__PURE__*/_jsx(ReadoutLessonBoxUnstarted, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        "data-test-id": "track-total-lessons",
        message: "academyComponents.reducedContentCards.numLessonsRemainingUnstarted",
        options: {
          remainingNumber: remainingLessons
        }
      })
    }), !showProgress && /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(FormattedDuration, {
        from: new Date().getTime() - totalTime * 1000
      })
    })]
  });
};